import React from 'react'
import { baseUrl } from '@fs/zion-config'
import Head, { Title } from '@fs/zion-head'

function getImageType(imageUrl = '') {
  let imageType = 'image/jpeg'
  if (imageUrl.match(/\.png/gi)) imageType = 'image/png'
  if (imageUrl.match(/\.gif/gi)) imageType = 'image/gif'
  if (imageUrl.match(/\.svg/gi)) imageType = 'image/svg+xml'
  return imageType
}

/**
 * @param {object} props
 * @param {string} props.title
 * @param {string} props.description
 * @param {string} props.ogTitle Open Graph title (falls back to title if not provided)
 * @param {string} props.ogDescription Open Graph description (falls back to description if not provided)
 * @param {string} props.imageSrc
 * @param {number} props.imageWidth
 * @param {number} props.imageHeight
 * @param {string} props.keywords
 * @param {string} props.canonicalLink
 */
export default function PageHead({
  title,
  description,
  ogTitle,
  ogDescription,
  imageSrc,
  imageWidth,
  imageHeight,
  keywords,
  children,
  canonicalLink,
}) {
  let canonicalLinkFinal = canonicalLink || globalThis?.location.pathname
  canonicalLinkFinal = canonicalLinkFinal?.includes('http') ? canonicalLinkFinal : `${baseUrl}${canonicalLinkFinal}`

  return (
    <>
      {title && <Title omitSiteName>{title}</Title>}
      <Head>
        <link rel="canonical" href={canonicalLinkFinal} />
        {description && <meta name="description" content={description} />}
        {keywords && <meta name="keywords" content={keywords} />}

        {imageSrc && <meta property="og:image" content={imageSrc} />}
        {imageSrc && <meta property="og:image:type" content={getImageType(imageSrc)} />}
        {!!imageWidth && <meta property="og:image:width" content={imageWidth} />}
        {!!imageHeight && <meta property="og:image:height" content={imageHeight} />}
        {imageSrc && <meta property="og:image:alt" content={title} />}
        {(ogTitle || title) && <meta property="og:title" content={ogTitle || title} />}
        {(ogDescription || description) && <meta property="og:description" content={ogDescription || description} />}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="FamilySearch" />
        <meta property="og:url" content={globalThis?.location.href} />

        {title && <meta name="twitter:title" content={title} />}
        {description && <meta name="twitter:description" content={description} />}
        <meta name="twitter:card" content={imageSrc ? 'summary_large_image' : 'summary'} />
        <meta name="twitter:site" content="@familysearch" />
        <meta name="twitter:creator" content="@familysearch" />
        {imageSrc && <meta name="twitter:image" content={imageSrc} />}
        {imageSrc && <meta name="twitter:image:alt" content={title} />}

        <meta property="fb:app_id" content="1261365907621824" />
        {children}
      </Head>
    </>
  )
}
